// extracted by mini-css-extract-plugin
export default {"calenderEventsMainSection":"meetingRoomSection_calenderEventsMainSection__9GS9-"};